import React, { useEffect, useRef, useState } from 'react';
import GeoSearchProps from '../interfaces/GeoSearchProps';
import Place from '../interfaces/Place';

const GeoSearch: React.FC<GeoSearchProps> = ({ setPlace, initialPlace }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [inputValue, setInputValue] = useState(initialPlace?.address || '');

  useEffect(() => {
    const handleKeyPress = (event: KeyboardEvent) => {
      if (event.key === 'Enter') {
        event.preventDefault(); 
        event.stopPropagation();
      } 
    };

    if (inputRef.current) {
      const autocomplete = new window.google.maps.places.Autocomplete(inputRef.current);
      autocomplete.setComponentRestrictions({ 'country': ['ar'] });

      if (initialPlace?.address) {
        setInputValue(initialPlace.address);
      }

      autocomplete.addListener('place_changed', () => {
        const response = autocomplete.getPlace();
        if (response?.geometry === undefined)
          return;
        const place: Place = {
          address: response.name as string,
          geometry: {
            location: {
              lat: response.geometry!.location!.lat(),
              lng: response.geometry!.location!.lng()
            }
          }
        };
        setPlace(place);
        setInputValue(response.name as string); // Update input value to selected suggestion
      });

      inputRef.current.addEventListener('keypress', handleKeyPress);
    }

    return () => {
      if (inputRef.current) {
        inputRef.current.removeEventListener('keypress', handleKeyPress);
      }
    }
  }, [setPlace, initialPlace]);

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setInputValue(event.target.value);
  };

  return (
    <div>
      <input 
        ref={inputRef} 
        type="text" 
        placeholder="Ingrese una ubicación" 
        value={inputValue}
        onChange={handleInputChange}
      />
    </div>
  );
};

export default GeoSearch;
